import http from 'conversations-http/clients/http';
export const bulkFetchValidatedViewMembers = ({
  objectIds,
  objectTypeId,
  viewId,
  quickFilters
}) => {
  return http.post('conversations-custom-views/v1/view-members/realtime-fetch', {
    data: {
      objectIds,
      objectTypeId,
      customViewId: viewId,
      quickFilters
    }
  });
};